import { Component, OnInit, ViewChild } from '@angular/core';
import { PrestationService } from '../shared/services/prestation.service';
import { TypePrestationService } from '../shared/services/type-prestation.service';
import { ExpertiseService } from '../shared/services/expertise.service';
import { Prestation } from '../shared/models/prestation';
import { Expertise } from '../shared/models/expertise';
import * as moment from 'moment';
@Component({
  selector: 'app-last-prestations',
  templateUrl: './last-prestations.component.html',
  styleUrls: ['./last-prestations.component.scss']
})
export class LastPrestationsComponent implements OnInit {

    lastPrestationId: number = 0;
    savePrestationId: number = 0;
  	prestations: any[] = [];
    typePrestations: any[] = [];
    expertises: any[] = [];

    clonedPrestations: { [s: number]: Prestation; } = {};
    @ViewChild("dd", {static: false}) table;

  	constructor(private prestationService: PrestationService,
              private typePrestationService: TypePrestationService,
              private expertiseService: ExpertiseService ) { }

  	ngOnInit() {
  		this.prestationService.my().subscribe(p => {
        this.prestations = p;        
        console.log(this.expertises);
      });
      this.typePrestationService.get().subscribe( ts => this.typePrestations = ts);
      

  	}

    addPrestation() {
       this.lastPrestationId--;

       const prest = Object.assign(new Prestation, {         
         id: this.lastPrestationId,
         type: this.typePrestations[2]
       });      
       this.prestations.unshift(prest);
       this.table.editingRowKeys[this.lastPrestationId] = true;

    }

    onRowEditInit(prestation: Prestation) {
       this.clonedPrestations[prestation.id] = Object.assign(new Prestation,{...prestation});

    }
    onDeleteRow(prestation: Prestation) {
      this.prestationService.delete(prestation.id).subscribe(d => {
        this.prestations = this.prestations.filter(p => p.id !== prestation.id);    
      });
    }

    onRowEditSave(prestation: Prestation) {
        delete this.clonedPrestations[prestation.id];       
        this.savePrestationId = prestation.id;

        const prestationRequest = {
          id: prestation.id,
          expertise_id: prestation.expertise.id,
          quantity: prestation.quantity,
          comment: prestation.comment,
          type_prestation_id: prestation.type.id,
          date_prestation: moment(prestation.date_prestation).format('YYYY-MM-DD')
        };
        this.prestationService.update(prestationRequest).subscribe(d => {            
            if (this.savePrestationId > 0) {
              this.table.editingRowKeys[this.savePrestationId] = false;  
            }
            this.prestations = this.prestations.map(p => p.id !== this.savePrestationId ? p : d);    
            
        })
        
    }

    onRowEditCancel(prestation: Prestation, index: number) {
        if (this.clonedPrestations[prestation.id]) {
            this.prestations[index] = this.clonedPrestations[prestation.id];
            delete this.clonedPrestations[prestation.id];
        }
        else {
          this.prestations = this.prestations.filter(p => p.id !== prestation.id);
        }
    }

    

    searchExpertise(event) {
      console.log(event);
        this.expertiseService.getAll('id',1,{'number': event.query},1,20).subscribe(data => {
            this.expertises = data.body.map(e => Object.assign(new Expertise,e));
        });
    }    
}
